import { Form, Input } from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import Button from "../components/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SettingsAccount() {
  const { t } = useTranslation();

  return (
    <ContentLayout
      header={
        <>
          <h1>{t("your_account")}</h1>
          <MyBreadcrumb />
        </>
      }
    >
      <Form className="rewards-form" layout="vertical">
        <div className="rewards-form-section">
          <div className="rewards-inputs">
            <div className="form-row">
              <Form.Item name="streetNumber" label={t("first_name")} required>
                <Input />
              </Form.Item>
              <Form.Item name="streetName" label={t("last_name")} required>
                <Input />
              </Form.Item>
            </div>
            <Form.Item name="address" label={t("email_address")} required>
              <Input />
            </Form.Item>
            <div>
              <Form.Item name="phone" label={t("phone_number")} required>
                <Input />
              </Form.Item>
              <Form.Item name="website" label={t("website_url")} required>
                <Input />
              </Form.Item>
              <Form.Item
                name="password"
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {t("password")}
                    <Link
                      to="change-password"
                      style={{ textDecoration: "underline" }}
                    >
                      <h6>{t("change_password")}</h6>
                    </Link>
                  </div>
                }
              >
                <Input placeholder={t("password_placeholder")} disabled />
              </Form.Item>
            </div>
          </div>
        </div>

        <Form.Item className="rewards-form-btn">
          <Button>{t("save")}</Button>
        </Form.Item>
      </Form>
    </ContentLayout>
  );
}
